module.exports = __webpack_public_path__ + "static/media/app-image-with-text.50c66e29.png";